import { PERMISSIONS, can } from "../../../shared/permissions/index.js";
import SignType from "../signType";

export const ADMIN_SIGNED_TYPES = [
  SignType.presigned,
  SignType.presignedWithVideo,
  SignType.noAutograph,
];

export const requiresAdmin = (signedType) =>
  ADMIN_SIGNED_TYPES.includes(signedType);

const isAllowedFor = (user) => (signedType) =>
  (user.isAdmin || !requiresAdmin(signedType)) &&
  (signedType !== SignType.inPerson ||
    can(PERMISSIONS.PRODUCT_SET_FIXED_BUMP, null, user));

export const signedTypeOptionsFor = ({ signedTypes, user, current }) =>
  signedTypes.filter(
    (signedType) =>
      (signedType === SignType.inPerson && current === SignType.inPerson) ||
      isAllowedFor(user)(signedType),
  );
